import React from 'react';
import styled from 'styled-components';
import {
  Heading4,
  Body1,
  DoconToastBar,
} from '@docon/docon-ui-library';
import { colors } from 'utilities/colorConfig';

interface IProps {
  type: 'success' | 'info' | 'warning' | 'error';
  showIcon?: boolean;
  message: string | React.ReactNode;
  description?: string | React.ReactNode;
}

const Root = styled(DoconToastBar)`
  position: unset;
  left: unset;
  top: unset;
  transform: unset;
  border-radius: 4px;
  box-shadow: none;
  white-space: pre-line;
  border: 1px solid;
`;

function AlertMsg({
  message,
  description,
  ...props
}: IProps) {
  if (!(message || description))
    return null;

  const title = description ? message : '';
  return (
    <Root showCrossIcon={false} showIcon {...props}>
      <Heading4 mb='3px' title={title} />
      <Body1 title={description || message} color={colors.secondaryColor} />
    </Root>
  );
}

export default styled(AlertMsg)``;